// =============================================================================
// VulnTracker — Severity Badge Component
// =============================================================================
import clsx from 'clsx';
import type { Severity } from '@/types';

const severityConfig: Record<Severity, { label: string; className: string }> = {
  critical: { label: 'Critical', className: 'badge-critical' },
  high: { label: 'High', className: 'badge-high' },
  medium: { label: 'Medium', className: 'badge-medium' },
  low: { label: 'Low', className: 'badge-low' },
  none: { label: 'None', className: 'badge bg-gray-100 text-gray-800' },
};

interface Props {
  severity: Severity;
  className?: string;
}

export function SeverityBadge({ severity, className }: Props) {
  const config = severityConfig[severity] || severityConfig.none;
  return <span className={clsx(config.className, className)}>{config.label}</span>;
}
